/**
 * Insight / Profile / Context Service
 * v3 API (Claude + RAG) のクライアント
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://struct-code-production.up.railway.app';

const _token = () => localStorage.getItem('struct-code-token');
const _authHeaders = () => {
  const t = _token();
  return {
    'Content-Type': 'application/json',
    ...(t ? { Authorization: `Bearer ${t}` } : {}),
  };
};

const insightService = {
  /* ---------- Insight (テーマ別診断) ---------- */
  async listTopics() {
    const res = await fetch(`${API_BASE_URL}/api/v3/insight/topics`);
    if (!res.ok) throw new Error(`listTopics failed: ${res.status}`);
    return res.json();
  },

  async generate({ topic, context = null, additional_inputs = {} } = {}) {
    const res = await fetch(`${API_BASE_URL}/api/v3/insight`, {
      method: 'POST',
      headers: _authHeaders(),
      body: JSON.stringify({ topic, context, additional_inputs }),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.detail || `insight failed: ${res.status}`);
    }
    return res.json();
  },

  /* ---------- Profile ---------- */
  async getProfile() {
    const res = await fetch(`${API_BASE_URL}/api/v3/profile`, {
      headers: _authHeaders(),
    });
    if (!res.ok) throw new Error(`getProfile failed: ${res.status}`);
    return res.json();
  },

  async patchProfile(payload) {
    const res = await fetch(`${API_BASE_URL}/api/v3/profile`, {
      method: 'PATCH',
      headers: _authHeaders(),
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`patchProfile failed: ${res.status}`);
    return res.json();
  },

  /* ---------- Context (集約) ---------- */
  async getContext() {
    const res = await fetch(`${API_BASE_URL}/api/v3/context`, {
      headers: _authHeaders(),
    });
    if (!res.ok) throw new Error(`getContext failed: ${res.status}`);
    return res.json();
  },
};

export default insightService;
